import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { makeEntityChildrenIdsSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import Component, { type ImageGalleryComponentProps } from "./component";

const makeMapStateToProps = () => {
  const itemsIdsSelector = makeEntityChildrenIdsSelector();

  return (state: AppState, props: RootContainerProps): ImageGalleryComponentProps => {
    return {
      ...props,
      itemsIds: itemsIdsSelector(state, props)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
